module.exports = __webpack_public_path__ + "2312c118999cc9f5207c193a3c5a520a.pdf";